import { render } from "./SeeNotice.vue?vue&type=template&id=5c194d54&scoped=true"
import script from "./SeeNotice.vue?vue&type=script&lang=js"
export * from "./SeeNotice.vue?vue&type=script&lang=js"

import "./SeeNotice.vue?vue&type=style&index=0&id=5c194d54&scoped=true&lang=scss"

import exportComponent from "/data/jenkins/workspace/talk-community-h5-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c194d54"]])

export default __exports__